import React from "react";
import classnames from "classnames";
import get from "lodash/get";
import { useSelector } from "react-redux";

import { Update } from "custom-types/Update";
import { getCurrentDispensary } from "redux/selectors/dispensary";

import ExpandableContainer from "components/botanic/ExpandableContainer";

const DispensaryUpdate: React.FC<{ update: Update; className?: string }> = ({
  update,
  className = "bg-white",
}) => {
  const { timeZone } = useSelector(getCurrentDispensary);

  const hideExpander = get(update, "updateText.length", 0) < 150;

  const formattedDate = new Date(update.lastModified).toLocaleDateString(
    "en-US",
    {
      day: "numeric",
      month: "long",
      timeZone: timeZone,
      year: "numeric",
    }
  );

  const theme = className.includes("bg-leafly-white")
    ? "leafly-white"
    : "white";

  return (
    <>
      <div className={classnames("py-sm px-md", className)}>
        <div>
          <div>
            <div className="text-base text-deep-green">{update.title}</div>
            <div className="text-deep-green text-xs text-left">
              {formattedDate}
            </div>
          </div>
          <ExpandableContainer
            hide={hideExpander}
            theme={theme}
            initialHeight="72px"
          >
            <p className="text-sm">{update.updateText}</p>
          </ExpandableContainer>
        </div>
      </div>
      <style jsx>{`
        .dispensary-update__content {
          font-size: 12px;
          max-height: 70px;
          overflow: hidden;
          position: relative;
        }

        .dispensary-update__content.open {
          max-height: none;
        }

        .dispensary-update__content::after {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
        }

        .dispensary-update__content.expandable::after {
          background-image: linear-gradient(
            rgba(255, 255, 255, 0) 50%,
            rgba(255, 255, 255, 1) 100%
          );
        }

        .dispensary-update__content.open::after {
          background-image: none;
        }

        .dispensary-update__expander {
          font-size: 12px;
          font-style: italic;
          color: #67a63a;
          cursor: pointer;
          text-align: center;
          width: 100%;
        }

        .dispensary-update__expander:focus {
          outline: none;
        }
      `}</style>
    </>
  );
};

export default DispensaryUpdate;
